import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './AdminLayout.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply the saved console appearance before React renders so public routes,
// including /login, use the same theme without a light/default color flash.
const savedThemeMode = localStorage.getItem('adminThemeMode') || 'system';
const savedAdminColor = localStorage.getItem('adminPrimaryColor') || 'matrimony';
const allowedColors = ['matrimony', 'blue', 'violet', 'emerald', 'rose', 'orange'];
const resolvedTheme = savedThemeMode === 'system'
  ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  : (savedThemeMode === 'dark' ? 'dark' : 'light');

document.documentElement.dataset.adminTheme = resolvedTheme;
document.documentElement.dataset.adminThemeMode = savedThemeMode;
document.documentElement.dataset.adminColor = allowedColors.includes(savedAdminColor) ? savedAdminColor : 'matrimony';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
